import { Icons } from '@/assets/icons/icons';
import { cn } from '@/lib/utils';

import type { ReactNode } from 'react';

type ExternalLinkProps = {
  href: string;
  children: ReactNode;
  className?: string;
  'data-find-field'?: string;
};

export const ExternalLink = ({
  href,
  children,
  className,
  'data-find-field': findField,
}: ExternalLinkProps) => (
  <a
    data-find-field={findField}
    href={href}
    target="_blank"
    rel="noreferrer"
    onClick={(event) => event.stopPropagation()}
    className={cn(
      'group/external no-underline transition-colors hover:text-foreground focus-visible:text-foreground',
      className
    )}
  >
    {children}
    <Icons.arrowUpRight
      aria-hidden="true"
      className="ml-1 inline size-[1em] align-[-0.125em] text-foreground-muted group-hover/external:text-foreground group-focus-visible/external:text-foreground"
    />
  </a>
);
